import React from 'react';
import Icon from './Icon';

/**
 * Empty-state component used inside panels and pages.
 */
export default function EmptyState({
  icon = 'emptyState',
  title,
  hint,
  action,
  style,
  ...rest
}) {
  return (
    <div
      style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        padding: '40px var(--sp-5)', gap: 'var(--sp-2)', textAlign: 'center',
        ...style,
      }}
      {...rest}
    >
      {icon && (
        <div style={{
          opacity: 1,
          color: 'var(--text-muted)',
          width: 52, height: 52,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          borderRadius: 'var(--radius-lg)',
          background: 'var(--bg-elevated)',
          border: '1px solid var(--border-subtle)',
          marginBottom: 'var(--sp-1)',
        }}>
          {typeof icon === 'string'
            ? <Icon name={icon} size={24} strokeWidth={1.4} />
            : icon}
        </div>
      )}
      {title && (
        <div style={{
          fontSize: 'var(--fs-sm)', fontWeight: 'var(--fw-semi)',
          color: 'var(--text-secondary)',
        }}>
          {title}
        </div>
      )}
      {hint && (
        <div style={{
          fontSize: 'var(--fs-xs)', color: 'var(--text-muted)',
          maxWidth: 280, lineHeight: 'var(--lh-base)',
        }}>
          {hint}
        </div>
      )}
      {action && <div style={{ marginTop: 'var(--sp-2)' }}>{action}</div>}
    </div>
  );
}
